/**
 * Reversement aux déposants.
 *
 * Règle boutique : le 15 de chaque mois, la boutique sort les ventes de tous
 * ses déposants — y compris celle de la veille. Paiement en espèces, et par
 * virement bancaire au-delà de 3 000 €.
 */
/** Seuil au-delà duquel le reversement part obligatoirement en virement. */
export const SEUIL_VIREMENT_CENTIMES = 300_000;
/** Jour du mois où la boutique sort les ventes de ses déposants. */
export const JOUR_PAIEMENT = 15;
export function modeReversement(montantCentimes) {
    return montantCentimes > SEUIL_VIREMENT_CENTIMES ? 'virement' : 'especes';
}
/**
 * Date à laquelle une vente devient payable au déposant : le prochain 15.
 *
 * Une pièce vendue le 14 juillet se paie le 15 juillet — la veille compte.
 * Vendue le 16 juillet, elle attend le 15 août. Il n'y a donc jamais plus d'un
 * mois entre la vente et le règlement.
 */
export function dateOuverturePaiement(dateVente) {
    const vente = typeof dateVente === 'string' ? new Date(dateVente) : dateVente;
    const moisSuivant = vente.getDate() > JOUR_PAIEMENT ? 1 : 0;
    const ouverture = new Date(vente.getFullYear(), vente.getMonth() + moisSuivant, JOUR_PAIEMENT);
    ouverture.setHours(0, 0, 0, 0);
    return ouverture;
}
/** Cette vente peut-elle être réglée au déposant aujourd'hui ? */
export function estPayableMaintenant(dateVente, maintenant = new Date()) {
    return maintenant.getTime() >= dateOuverturePaiement(dateVente).getTime();
}
/** Le guichet de paiement est-il ouvert ce mois-ci (le 15 ou après) ? */
export function estPayable(maintenant = new Date()) {
    return maintenant.getDate() >= JOUR_PAIEMENT;
}
/** « à partir du 15 août » — pour expliquer une somme encore en attente. */
export function libelleOuverture(dateVente) {
    const ouverture = dateOuverturePaiement(dateVente);
    return `à partir du ${ouverture.getDate()} ${MOIS_FR[ouverture.getMonth()]} ${ouverture.getFullYear()}`;
}
/** « juillet 2026 » — la période à laquelle une vente est rattachée. */
export function periodeDe(date) {
    const d = typeof date === 'string' ? new Date(date) : date;
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
const MOIS_FR = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
];
/** « 2026-07 » → « juillet 2026 ». */
export function libellePeriode(periode) {
    const [annee, mois] = periode.split('-');
    const index = Number(mois) - 1;
    return `${MOIS_FR[index] ?? mois} ${annee}`;
}
//# sourceMappingURL=reversement.js.map